"use strict";

/**
 * Desktop main nav: click disclosure.
 * Top-level items → is-submenu-open (CSS handles visibility/position).
 * Nested items with children → is-expanded (CSS positions flyout via
 *   position:absolute on a li[position:relative] parent, inset-inline-start:100%).
 * The parent dropdown uses overflow:visible so the flyout is never clipped.
 */
(function () {
  function findChildSubmenu(el) {
    return Array.from(el.children).find(function (c) {
      return c.classList && c.classList.contains("navigation-sub-menu");
    });
  }

  function closeTopFlyout(li) {
    if (!li) return;
    li.querySelectorAll(".has-sub-menu.is-expanded").forEach(function (el) {
      el.classList.remove("is-expanded");
    });
    var panel = findChildSubmenu(li);
    if (panel) {
      ["display", "visibility", "opacity", "pointer-events", "max-height",
       "overflow", "overflow-x", "overflow-y", "z-index"].forEach(function (p) {
        panel.style.removeProperty(p);
      });
    }
    li.classList.remove("is-submenu-open");
    var btn = Array.from(li.children).find(function (c) {
      return c.matches && c.matches("button.navigation-menu-trigger");
    });
    if (btn) btn.setAttribute("aria-expanded", "false");
  }

  function isTopLevelFlyoutItem(li, mainNav) {
    return Boolean(
      li && mainNav && li.parentElement === mainNav && li.classList.contains("has-sub-menu"),
    );
  }

  function openTopPanel(li) {
    var panel = findChildSubmenu(li);
    if (!panel) return;
    panel.style.setProperty("display", "block", "important");
    panel.style.setProperty("visibility", "visible", "important");
    panel.style.setProperty("opacity", "1", "important");
    panel.style.setProperty("pointer-events", "auto", "important");
    var isMega = panel.classList.contains("mega-menu");
    panel.style.setProperty("max-height", isMega ? "85vh" : "min(70vh, 40rem)", "important");
    panel.style.setProperty("z-index", "100", "important");
  }

  function onDocumentClick(event) {
    var t = event.target;

    /* ── Top-level trigger ── */
    var trigger = t.closest("button.navigation-menu-trigger");
    if (trigger) {
      var mainNav = trigger.closest(".navigation-menu.navigation-main");
      var li = trigger.parentElement;
      if (isTopLevelFlyoutItem(li, mainNav)) {
        event.preventDefault();
        event.stopPropagation();

        var wasOpen = li.classList.contains("is-submenu-open");

        /* close any other open top flyout */
        document.querySelectorAll(".navigation-menu.navigation-main").forEach(function (nav) {
          Array.from(nav.children).forEach(function (child) {
            if (
              child.classList.contains("has-sub-menu") &&
              child.classList.contains("is-submenu-open") &&
              child !== li
            ) {
              closeTopFlyout(child);
            }
          });
        });

        if (wasOpen) {
          closeTopFlyout(li);
        } else {
          li.classList.add("is-submenu-open");
          trigger.setAttribute("aria-expanded", "true");
          openTopPanel(li);
        }
        return;
      }
    }

    /* ── Nested link with children ── */
    var nestedLink = t.closest(".navigation-menu.navigation-main .navigation-sub-menu a");
    if (nestedLink && nestedLink.tagName === "A") {
      var submenuItem = nestedLink.parentElement;
      var mainNav2 = nestedLink.closest(".navigation-menu.navigation-main");
      var childMenu = submenuItem ? findChildSubmenu(submenuItem) : null;
      if (
        mainNav2 &&
        submenuItem &&
        submenuItem.classList.contains("has-sub-menu") &&
        nestedLink === submenuItem.querySelector("a") &&
        childMenu &&
        submenuItem.parentElement !== mainNav2
      ) {
        event.preventDefault();
        event.stopPropagation();

        var isExpanded = submenuItem.classList.contains("is-expanded");

        /* close siblings */
        Array.from(submenuItem.parentElement.children).forEach(function (item) {
          if (item !== submenuItem && item.classList.contains("has-sub-menu")) {
            item.classList.remove("is-expanded");
          }
        });

        submenuItem.classList.toggle("is-expanded", !isExpanded);
        return;
      }
    }

    /* ── Click outside → close ── */
    document
      .querySelectorAll(".navigation-menu.navigation-main > .has-sub-menu.is-submenu-open")
      .forEach(function (openLi) {
        if (!openLi.contains(t)) closeTopFlyout(openLi);
      });
  }

  function onDocumentKeydown(event) {
    if (event.key === "Escape") {
      var openLi = document.querySelector(
        ".navigation-menu.navigation-main > .has-sub-menu.is-submenu-open",
      );
      if (!openLi) return;
      event.preventDefault();
      var nestedExpanded = openLi.querySelector(
        ".navigation-sub-menu .has-sub-menu.is-expanded",
      );
      if (nestedExpanded) {
        nestedExpanded.classList.remove("is-expanded");
        var a = nestedExpanded.querySelector("a");
        if (a) a.focus();
        return;
      }
      var btn = openLi.querySelector("button.navigation-menu-trigger");
      closeTopFlyout(openLi);
      if (btn) btn.focus();
      return;
    }

    if (event.key !== "Enter" && event.key !== " ") return;
    var el = document.activeElement;
    if (!el) return;

    if (el.matches("button.navigation-menu-trigger")) {
      var mainNav3 = el.closest(".navigation-menu.navigation-main");
      var li3 = el.parentElement;
      if (isTopLevelFlyoutItem(li3, mainNav3)) {
        event.preventDefault();
        el.click();
      }
      return;
    }

    if (el.tagName !== "A") return;
    var submenuItem2 = el.closest(".navigation-sub-menu li.has-sub-menu");
    if (!submenuItem2 || el !== submenuItem2.querySelector("a")) return;
    var mainNav4 = el.closest(".navigation-menu.navigation-main");
    if (!mainNav4 || !findChildSubmenu(submenuItem2) || submenuItem2.parentElement === mainNav4) return;
    event.preventDefault();
    el.click();
  }

  function boot() {
    document.addEventListener("click", onDocumentClick);
    document.addEventListener("keydown", onDocumentKeydown);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
